import script from "./CreateRecord.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateRecord.vue?vue&type=script&lang=ts&setup=true"

import "./CreateRecord.vue?vue&type=style&index=0&id=11de2329&lang=less&scoped=true"

import exportComponent from "D:\\鹿小岚\\crm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11de2329"]])

export default __exports__